/**
 * OLA Cosmetics — Collection View Toggle (Grid / List)
 * Supports: 2-col, 3-col, 4-col grid views + list view.
 * Preference saved in localStorage.
 * Works with [data-collection-grid] container.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'ola_collection_view';
  const GRID_CLASS  = 'collection-grid';
  const VIEWS = ['grid-2', 'grid-3', 'grid-4', 'list'];

  function init() {
    const container = document.querySelector('[data-collection-grid]');
    const toggleBar = document.querySelector('[data-view-toggles]');
    if (!container || !toggleBar) return;

    // Read saved preference; default to grid-3
    const saved = localStorage.getItem(STORAGE_KEY) || 'grid-3';
    applyView(container, saved);

    // Activate the saved button
    const savedBtn = toggleBar.querySelector(`[data-view="${saved}"]`);
    if (savedBtn) setActiveBtn(toggleBar, savedBtn);

    // Bind toggle buttons
    toggleBar.querySelectorAll('[data-view]').forEach(btn => {
      btn.addEventListener('click', () => {
        const view = btn.getAttribute('data-view');
        applyView(container, view);
        setActiveBtn(toggleBar, btn);
        localStorage.setItem(STORAGE_KEY, view);
      });
    });
  }

  function applyView(container, view) {
    // Remove all view classes
    VIEWS.forEach(v => container.classList.remove(`${GRID_CLASS}--${v}`));
    container.classList.add(`${GRID_CLASS}--${view}`);

    // Add transition class for smooth re-layout
    container.classList.add(`${GRID_CLASS}--animating`);
    const tid = setTimeout(() => container.classList.remove(`${GRID_CLASS}--animating`), 350);
  }

  function setActiveBtn(bar, activeBtn) {
    bar.querySelectorAll('[data-view]').forEach(btn => {
      btn.classList.toggle('view-toggle--active', btn === activeBtn);
      btn.setAttribute('aria-pressed', String(btn === activeBtn));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
